export const inboundRouteTypes = {
  IVR: 'IVR',
  AUDIO: 'AUDIO',
  CALLBACK: 'CALLBACK',
  QUEUE: 'QUEUE',
  RING_GROUP: 'RING_GROUP',
  EXTENSION: 'EXTENSION',
  GENERIC_EXTENSION: 'GENERIC_EXTENSION',
  CUSTOMIZED: 'CUSTOMIZED'
};
